var _rect, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 -9 58 58",
    width: 58,
    height: 58,
    fill: "none",
    role: "img",
    "aria-label": "Discover",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 57,
    height: 39,
    rx: 3.5,
    fill: "#fff",
    stroke: "#F3F3F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.069 20.322c0 2.443 1.918 4.336 4.385 4.336.698 0 1.295-.137 2.032-.484v-1.908c-.648.649-1.222.91-1.956.91-1.633 0-2.791-1.183-2.791-2.866 0-1.595 1.195-2.853 2.715-2.853.773 0 1.358.276 2.032.935v-1.907c-.711-.36-1.296-.51-1.994-.51-2.455 0-4.423 1.932-4.423 4.347m-4.159-2.017c0 .449.285.686 1.258 1.046 1.843.674 2.39 1.271 2.39 2.592 0 1.608-1.182 2.728-2.866 2.728-1.233 0-2.13-.486-2.876-1.582l1.047-1.008c.373.721.995 1.108 1.768 1.108.724 0 1.259-.499 1.259-1.172 0-.349-.163-.648-.486-.86-.163-.1-.486-.249-1.12-.473-1.523-.548-2.045-1.134-2.045-2.278 0-1.36 1.121-2.38 2.592-2.38.91 0 1.744.31 2.441.92l-.848 1.11c-.422-.473-.821-.672-1.307-.672-.698 0-1.207.397-1.207.92m-4.325 6.166h1.62v-8.308h-1.62zm-3.313-2.067c-.51.46-1.17.66-2.218.66H4.62V17.57h.435c1.047 0 1.683.188 2.218.672.56.499.898 1.273.898 2.068 0 .798-.338 1.595-.898 2.094M5.38 16.163H3v8.308h2.366c1.259 0 2.167-.297 2.965-.96a4.17 4.17 0 001.508-3.188c0-2.453-1.832-4.16-4.46-4.16m30.741 0l2.216 5.58 2.244-5.58h1.757l-3.59 8.521h-.872l-3.525-8.521zm6.95 8.308h4.596v-1.407h-2.977v-2.242h2.867v-1.408H44.69V17.57h2.977v-1.408H43.07zm7.288-4.484h.473c1.035 0 1.584-.45 1.584-1.284 0-.809-.549-1.232-1.558-1.232h-.5zm.784-3.825c1.869 0 2.94.898 2.94 2.453 0 1.272-.672 2.108-1.892 2.356l2.615 3.5h-1.993l-2.243-3.338h-.211v3.338h-1.62v-8.309z",
    fill: "#1D1D1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.159 22.727a4.42 4.42 0 10-7.447-4.762 4.42 4.42 0 107.447 4.762",
    fill: "url(#discover__a)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "discover__a",
    x1: 36.54,
    y1: 19.003,
    x2: 29.093,
    y2: 14.241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6A000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.624,
    stopColor: "#E47E02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D36002"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "static/media/discover.a91735aaa5386958d710ecdd475cafe7.svg";
export { ForwardRef as ReactComponent };